





































































import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import QRCode from 'qrcodejs2'
@Component({
    components: {
    },
})
export default class openingPrompt extends Vue {
    public $refs: {
    };

    show = false;

    //二维码
    QRCode = null
    qrcode = null

    created() {
    }
    mounted() {
        
    }

   showFun(){
        this.show = true;
        let url = window.location.host.indexOf('test')>-1?'https://test-posm.hftopos.com/#/h5/h5login':'https://posm.hftopos.com/#/h5/h5login';
        this.$nextTick(()=>{
                this.getEwm(url);
        })
   }
    closeFun(){
        this.show = false;
    }

    //获取二维码
    getEwm(val){
        let qrCode = val;
        this.QRCode = qrCode;
        let qrcodeDiv = document.getElementById("SetQRCode")
        let qrcode = new QRCode(qrcodeDiv,{
            text:this.QRCode,//二维码中的内容
            width:150,
            height:150,
            colorDark:"#000",//二维码颜色
            correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
            }) 
        this.qrcode = qrcode;
        let childs = document.getElementById("SetQRCode").childNodes;
        for(let i = childs.length -2 ; i>=0 ; i--){
            document.getElementById("SetQRCode").removeChild(childs[i]);
        }
    }


    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/openingPrompt.vue